import { SearchViewMode, } from "../../hooks/types";
import { FetchStatus } from "../use-bind-data-fetchers/types";
var getResult = function (_a) {
    var search = _a.search, counts = _a.counts, data = _a.data;
    var result = {};
    if (search && !search.stale) {
        result.searchResult = search.result;
        result.searchStatus = search.status;
        result.searchError = search.error;
    }
    if (counts && !counts.stale) {
        result.counts = counts.result;
        result.countsStatus = counts.status;
        result.countsError = counts.error;
    }
    if (data && !data.stale) {
        result.data = data.result;
        result.dataStatus = data.status;
        result.dataError = data.error;
    }
    return result;
};
var getStatuses = function (_a) {
    var search = _a.search, counts = _a.counts, data = _a.data;
    var result = {};
    if (search && !search.stale) {
        result.searchStatus = search.status;
        result.searchError = search.error;
    }
    if (counts && !counts.stale) {
        result.countsStatus = counts.status;
        result.countsError = counts.error;
    }
    if (data && !data.stale) {
        result.dataStatus = data.status;
        result.dataError = data.error;
    }
    return result;
};
var updateResult = function (result, setResult, options) {
    if (Object.keys(result).length) {
        setResult(result, options);
    }
};
var setSearchResult = function (fetchStatus, result, setResult, options) {
    if (fetchStatus === FetchStatus.Success) {
        updateResult(getResult(result), setResult, options);
    }
    else if (fetchStatus === FetchStatus.Failure) {
        updateResult(getStatuses(result), setResult, options);
    }
};
var setSearchResultAndPageNumber = function (fetchStatus, result, setResult, pageNumber, setPageNumber, options) {
    setSearchResult(fetchStatus, result, setResult, options);
    if (fetchStatus === FetchStatus.Success && pageNumber != null) {
        setPageNumber(pageNumber, { noSearch: true });
    }
};
export var getResultSetters = function (actions, options) {
    var _a, _b;
    var setters = {
        search: function (status, result, error) {
            setSearchResult(status, { search: { result: result, status: status, stale: false, error: error } }, actions.setResult, options);
        },
        counts: function (status, result, error) {
            setSearchResult(status, { counts: { result: result, status: status, stale: false, error: error } }, actions.setResult, options);
        },
        data: (_a = {},
            _a[SearchViewMode.ListView] = function (status, result, pageNumber, error) {
                setSearchResultAndPageNumber(status, {
                    data: {
                        result: result,
                        status: status,
                        stale: false,
                        error: error,
                    },
                }, actions.setResult, pageNumber, actions.setPageNumber, options);
            },
            _a),
        searchWithData: (_b = {},
            _b[SearchViewMode.ListView] = function (status, result, data, pageNumber, error) {
                setSearchResultAndPageNumber(status, {
                    search: {
                        result: result,
                        status: status,
                        stale: false,
                        error: error,
                    },
                    data: {
                        result: data,
                        status: status,
                        stale: false,
                        error: error,
                    },
                }, actions.setResult, pageNumber, actions.setPageNumber, options);
            },
            _b),
    };
    if (actions.setMapViewResult) {
        setters.data[SearchViewMode.MapView] = function (status, result, pageNumber, error) {
            setSearchResultAndPageNumber(status, {
                data: {
                    result: result,
                    status: status,
                    stale: false,
                    error: error,
                },
            }, actions.setMapViewResult, pageNumber, actions.setPageNumber, options);
        };
        setters.searchWithData[SearchViewMode.MapView] = function (status, result, data, pageNumber, error) {
            setSearchResultAndPageNumber(status, {
                search: {
                    result: result,
                    status: status,
                    stale: false,
                    error: error,
                },
                data: {
                    result: data,
                    status: status,
                    stale: false,
                    error: error,
                },
            }, actions.setMapViewResult, pageNumber, actions.setPageNumber, options);
        };
    }
    if (actions.setGalleryViewResult) {
        setters.data[SearchViewMode.GalleryView] = function (status, result, pageNumber, error) {
            setSearchResultAndPageNumber(status, {
                data: {
                    result: result,
                    status: status,
                    stale: false,
                    error: error,
                },
            }, actions.setGalleryViewResult, pageNumber, actions.setPageNumber, options);
        };
        setters.searchWithData[SearchViewMode.GalleryView] = function (status, result, data, pageNumber, error) {
            setSearchResultAndPageNumber(status, {
                search: {
                    result: result,
                    status: status,
                    stale: false,
                    error: error,
                },
                data: {
                    result: data,
                    status: status,
                    stale: false,
                    error: error,
                },
            }, actions.setGalleryViewResult, pageNumber, actions.setPageNumber, options);
        };
    }
    return setters;
};
export var normalizeResult = function (result) { return result !== null && result !== void 0 ? result : []; };
export var registerSearchPerformedAppEvent = function (appEvents, criteria) {
    var _a, _b;
    if (criteria && ((_a = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _a === void 0 ? void 0 : _a.searchPerformed)) {
        (_b = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _b === void 0 ? void 0 : _b.searchPerformed({
            criteria: criteria,
        });
    }
};
export var registerResultsViewedAppEvent = function (appEvents, viewMode, keys) {
    var _a, _b, _c, _d, _e, _f;
    if (viewMode === undefined || viewMode === null) {
        throw new Error("viewMode must be provided.");
    }
    if (keys === null || keys === void 0 ? void 0 : keys.length) {
        switch (viewMode) {
            case SearchViewMode.GalleryView:
                ((_a = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _a === void 0 ? void 0 : _a.galleryResultsViewed) &&
                    ((_b = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _b === void 0 ? void 0 : _b.galleryResultsViewed({
                        keys: keys,
                    }));
                break;
            case SearchViewMode.ListView:
                ((_c = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _c === void 0 ? void 0 : _c.listViewResultsViewed) &&
                    ((_d = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _d === void 0 ? void 0 : _d.listViewResultsViewed({
                        keys: keys,
                    }));
                break;
            case SearchViewMode.MapView:
                ((_e = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _e === void 0 ? void 0 : _e.placardResultsViewed) &&
                    ((_f = appEvents === null || appEvents === void 0 ? void 0 : appEvents.dataFetchers) === null || _f === void 0 ? void 0 : _f.placardResultsViewed({
                        keys: keys,
                    }));
                break;
        }
    }
};
//# sourceMappingURL=helpers.js.map